<template>
    <div>
        <div class="my-white-mod" style="min-height:500px;padding-bottom:30px" >
            <div class="money-title">
                <h1 >销售额排名 </h1>            
                <DatePicker
                    :open="open_day"
                    :value="search_day"
                    type="date"
                    @on-change="handleChange"
                    style="margin-left:10px;cursor: pointer;"
                >
                    <span @click="handleClick"><Icon type="md-calendar" size="20"  />
                        <template v-if="search_day === getTodayDate()">今日</template>
                        <template v-else>{{ search_day }}</template>
                    </span>
                </DatePicker>
            </div>
            
            <Table border  height="500" :loading="table.loading"   :columns="table.columns" :data="table.data">
            </Table>
        </div>
    </div>
</template> 

<script>
    import {money_order} from "@/api/statistics"
    export default {
        name:"moneyOrder",
        props:{
        },
        data() {
            return {
                search_day:"",
                open_day:false,
                table:{
                    loading:false,
                    data:[],
                    columns: [
                        {
                            title: '排名',
                            align:'center',
                            type:'index',
                            width:80
                        },
                        {
                            title: '销售人员',
                            align:'center',
                            key: 'name',
                            render:(h, p)=>{
                                return h('span', p.row.name + "(" + p.row.alias + ")")
                            }
                        },
                        {
                            title: '日(销售)',
                            sortable: true,
                            align:'center',
                            key: 'day_money'
                        },
                        {
                            title: '日(退款)',
                            sortable: true,
                            align:'center',
                            key: 'day_refund_money'
                        },
                        {
                            title: '日(实际)',
                            sortable: true,
                            align:'center',
                            key: 'day_real_money'
                        },
                        {
                            title: '周',
                            sortable: true,
                            align:'center',
                            key: 'week_money'
                        },
                        {
                            title: '月',
                            sortable: true,
                            align:'center',
                            key: 'month_money'
                        },
                        {
                            title: '季度',
                            sortable: true,
                            align:'center',
                            key: 'quarter_money'
                        },
                        {
                            title: '年',
                            sortable: true,
                            align:'center',
                            key: 'year_money'
                        }
                    ]
                },
            }
        },
        created () {
                this.handleChange();
        },
        methods: {
            getTodayDate() {
                let date = new Date(),
                    year = date.getFullYear(), //获取完整的年份(4位)
                    month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
                    strDate = date.getDate() // 获取当前日(1-31)
                if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
                if (strDate < 10) strDate = `0${strDate}` // 如果日是个位数，在前面补0
                
                return `${year}-${month}-${strDate}`
            },
            handleChange(date){
                this.search_day = date ? date : this.getTodayDate();
                this.open_day = false
                this.getList()
            },
            handleClick(){
                this.open_day = !this.open_day
            },
            getList(){
                this.table.loading = true;
                money_order({day:this.search_day}).then(res=>{
                    this.table.loading = false;
                    if (res.code == 200) {
                        this.table.data = res.data;
                    } else {
                        this.table.data = [];
                        this.$Message.error(res.msg);
                    }
                }).catch(err=>{
                    this.table.loading = false;
                })
            }
        }
    }
</script>

<style scoped>
.ivu-table-wrapper-with-border{
    border-bottom:1px solid #dcdee2;
}
.font-left{
    font-size:20px;text-align: left;
}

.page-class{
    margin-top:10px;text-align: right
}
.money-title{
    display:flex;align-items: center
}
</style>